import { PaymentMethodsGenericActions } from '../../../components/payment-methods/actions/actions-generic';
import { ContextToProps } from '../context-to-props';

export type PaymentMethodsDefaultAchActionsProps = {
  shouldUsePadding?: boolean;
};

export const PaymentMethodsDefaultAchActions = (props: PaymentMethodsDefaultAchActionsProps) => {
  return (
    <ContextToProps.AchActions
      {...props}
      stripeComponent={PaymentMethodsGenericActions}
      justifiComponent={() => {
        console.warn('Justifi ACH actions are not supported yet');
        return <></>;
      }}
    />
  );
};
